<ng-container *ngIf="isLoading">
  <ng-container *ngTemplateOutlet="loader"></ng-container>
</ng-container>

<ng-container *ngIf="!isLoading && errors.length > 0">
  <div class="m-4 bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded shadow-md">
    <div class="flex items-center">
      <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"/>
      </svg>
      <h2 class="text-xl font-bold">Something went wrong:</h2>
    </div>
    <ul class="mt-2 ml-8 list-disc">
      <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading && !errors.length">
  <div class="max-w-2xl mx-auto my-8 bg-white rounded-lg shadow-lg overflow-hidden">
    <div class="bg-green-50 p-6 border-b border-green-100">
      <div class="flex items-center justify-center">
        <svg class="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <h1 class="text-center text-3xl mt-4 font-bold text-green-900">Order Confirmed!</h1>
    </div>
    
    <div class="p-6 space-y-6">
      <div class="flex items-center space-x-2">
        <svg class="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
        </svg>
        <p>
          A confirmation email will be sent to
          <span id="customer-email" class="font-semibold text-gray-900">{{ customerEmail }}</span>
        </p>
      </div>

      <div class="flex items-center space-x-2">
        <svg class="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd"/>
        </svg>
        <p>
          Order ID: <span class="font-semibold text-gray-900">{{ orderId }}</span>
        </p>
      </div>

      <div class="bg-green-50 p-4 rounded-lg">
        <p class="text-green-800">
          Track your order using
          <a class="text-green-800 hover:text-green-600 font-semibold underline" [routerLink]="['/sencha-steep-in-transit', orderId]">Sencha Steep in Transit</a>.
        </p>
      </div>

      <div class="border-t pt-6">
        <p class="text-gray-600">
          Questions? Email
          <a class="text-green-800 hover:text-green-600" href="mailto:orders@sencha-tea.com">orders&#64;sencha-tea.com</a>
        </p>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loader>
  <div class="max-w-2xl mx-auto my-8 p-6 bg-white rounded-lg shadow-lg">
    <div class="animate-pulse space-y-4">
      <div class="h-12 bg-gray-200 rounded-full w-12 mx-auto"></div>
      <div class="h-6 bg-gray-200 rounded w-3/4 mx-auto"></div>
      <div class="space-y-3">
        <div class="h-4 bg-gray-200 rounded w-5/6"></div>
        <div class="h-4 bg-gray-200 rounded w-4/6"></div>
        <div class="h-4 bg-gray-200 rounded w-3/6"></div>
      </div>
    </div>
  </div>
</ng-template>
